import React from 'react';
import Icon from '../../../components/AppIcon';

const LineOfBusinessTabs = ({ activeTab, onTabChange, practiceCount }) => {
  const tabs = [
    {
      id: 'otc',
      label: 'Order to Cash',
      shortLabel: 'OTC',
      icon: 'ShoppingCart',
      description: 'Sales order processing and revenue recognition',
      count: practiceCount?.otc || 0
    },
    {
      id: 'p2p',
      label: 'Procure to Pay',
      shortLabel: 'P2P',
      icon: 'Package',
      description: 'Procurement and vendor payment processes',
      count: practiceCount?.p2p || 0
    },
    {
      id: 'rtr',
      label: 'Record to Report',
      shortLabel: 'RTR',
      icon: 'FileText',
      description: 'Financial accounting and reporting',
      count: practiceCount?.rtr || 0
    },
    {
      id: 'plan',
      label: 'Plan to Produce',
      shortLabel: 'Plan',
      icon: 'Calendar',
      description: 'Production planning and manufacturing',
      count: practiceCount?.plan || 0
    },
    {
      id: 'ewm',
      label: 'Extended Warehouse',
      shortLabel: 'EWM',
      icon: 'Warehouse',
      description: 'Advanced warehouse management',
      count: practiceCount?.ewm || 0
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-1">
      <div className="flex flex-wrap gap-1">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            className={`flex items-center space-x-2 px-4 py-3 rounded-md nav-transition flex-1 min-w-0 ${
              activeTab === tab?.id
                ? 'bg-primary text-primary-foreground shadow-elevation-1'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
            title={tab?.description}
          >
            <Icon 
              name={tab?.icon} 
              size={18} 
              className="flex-shrink-0"
            />
            <div className="flex-1 min-w-0 text-left">
              <div className="text-sm font-medium truncate">
                <span className="hidden sm:inline">{tab?.label}</span>
                <span className="sm:hidden">{tab?.shortLabel}</span>
              </div>
              <div className={`text-xs ${
                activeTab === tab?.id ? 'text-primary-foreground/80' : 'text-muted-foreground'
              }`}>
                {tab?.count} practices
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LineOfBusinessTabs;